export enum ModalImagesEnum {
  base = 1,
  attention,
  confirm,
  recommendation,
  invite
}
